export default "__VITE_ASSET__eaa5007d__"